<h1 matDialogTitle>{{ 'Keys for {id} datasets' | translate: { id: '\'' + dataset.id + '\'' } }}</h1>

<mat-dialog-content>
  <p>
    {{ 'WARNING: Keys for all nested datasets with encryption applied will be downloaded.' | translate }}
  </p>
</mat-dialog-content>

<ix-form-actions matDialogActions>
  <button mat-button type="button" ixTest="close" [matDialogClose]="false">
    {{ 'Close' | translate }}
  </button>

  <button
    mat-button
    type="submit"
    color="primary"
    ixTest="download-keys"
    (click)="onDownload()"
  >
    {{ 'Download Keys' | translate }}
  </button>
</ix-form-actions>
